import type { HeadlineResponsePagedData } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { forwardSlashCheck } from '@on3/ui-lib/src/utils/forwardSlashCheck';
import { TextLink } from '@public/components/UI/Link/TextLink';

import { ArticleFeedAlternate } from './ArticleFeedAlternate';
import styles from './FeedListAlternate.module.scss';

interface IViewAllLinkProps {
  url: string;
  text: string;
  title: string;
}

interface IArticleFeedListProps extends HeadlineResponsePagedData {
  section?: string;
  viewAllLinks?: IViewAllLinkProps[];
}

export const FeedListAlternate = ({
  list = [],
  section,
  viewAllLinks,
}: IArticleFeedListProps) => {
  const isSportsBetting = viewAllLinks?.some((l) =>
    l.url.includes('sports-betting'),
  );

  if (!list?.length) return null;

  return (
    <section className={styles.block}>
      {section && (
        <header className={styles.header}>
          <h3 className={styles.headerText}>{section}</h3>
          {isSportsBetting && (
            <Link className={styles.promotional} href="https://www.betmgm.com/">
              <span>By</span>
              <img
                alt="BETMGM Logo"
                src="https://on3static.com/static/on3/mgm-branding.svg"
              />
            </Link>
          )}
        </header>
      )}
      {list.map((item, index) => (
        <ArticleFeedAlternate {...item} key={index} />
      ))}
      <footer className={styles.footer}>
        {viewAllLinks?.map(({ text, title, url }, index) => (
          <Link
            className={styles.footerLink}
            href={url}
            key={index}
            title={title}
          >
            {text}
          </Link>
        ))}
      </footer>
    </section>
  );
};
